var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24Z",
    fill: "#25D366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6 18.3C28.1 16.8 26.1 16 24 16C19.6 16 16 19.6 16 24C16 25.4 16.4 26.8 17.1 28L16 32L20.2 30.9C21.4 31.5 22.7 31.9 24 31.9C28.4 31.9 32 28.3 32 23.9C32 21.8 31.1 19.8 29.6 18.3ZM24 30.6C22.8 30.6 21.6 30.3 20.6 29.7L20.4 29.6L17.9 30.3L18.6 27.9L18.4 27.6C17.7 26.5 17.4 25.3 17.4 24.1C17.4 20.5 20.4 17.5 24 17.5C25.8 17.5 27.4 18.2 28.7 19.4C30 20.7 30.6 22.3 30.6 24.1C30.6 27.6 27.7 30.6 24 30.6ZM27.6 25.6C27.4 25.5 26.4 25 26.2 25C26 24.9 25.9 24.9 25.8 25.1C25.7 25.3 25.3 25.7 25.2 25.9C25.1 26 25 26 24.8 26C24.6 25.9 24 25.7 23.2 25C22.6 24.5 22.2 23.8 22.1 23.6C22 23.4 22.1 23.3 22.2 23.2C22.3 23.1 22.4 23 22.5 22.9C22.6 22.8 22.6 22.7 22.7 22.6C22.8 22.5 22.7 22.4 22.7 22.3C22.7 22.2 22.3 21.2 22.1 20.8C22 20.5 21.8 20.5 21.7 20.5C21.6 20.5 21.5 20.5 21.3 20.5C21.2 20.5 21 20.5 20.8 20.7C20.6 20.9 20.1 21.4 20.1 22.4C20.1 23.4 20.8 24.3 20.9 24.5C21 24.6 22.3 26.7 24.3 27.5C26 28.2 26.3 28 26.7 28C27.1 28 27.9 27.5 28 27.1C28.2 26.6 28.2 26.2 28.1 26.2C28 25.7 27.8 25.7 27.6 25.6Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.7bb321b06c05c4f8b205d8bae674518c.svg";
export { ForwardRef as ReactComponent };